import { ProjectListProject } from '@/views/project-forum/models/ProjectForum';
import { Industry } from '@/models/Tags';

export enum Lang {
  de = 'de-DE',
  en = 'en-US',
}

export enum UserRoles {
  MINIMUM_USER= 'MINIMUM_USER',
  SYSTEM_USER= 'SYSTEM_USER',
  ADMIN= 'ADMIN',
  BC_TEAM= 'BC_TEAM',
  FREELANCER= 'FREELANCER',
  COMPANY_GUEST= 'COMPANY_GUEST',
  COMPANY_EMPLOYEE= 'COMPANY_EMPLOYEE',
  COMPANY_ADMIN= 'COMPANY_ADMIN',
  COMPANY_ROOT= 'COMPANY_ROOT',
  USER_IN_REGISTRATION= 'USER_IN_REGISTRATION',
  USER_IN_APPROVAL= 'USER_IN_APPROVAL',
  ALL_USERS= 'ALL_USERS',
  TAG_MODERATOR= 'TAG_MODERATOR',
  PROJECT_MODERATOR= 'PROJECT_MODERATOR',
  PROJECT_CREATOR= 'PROJECT_CREATOR',
  FORUM_MODERATOR= 'FORUM_MODERATOR',
  VIDEO_CHAT_MODERATOR= 'VIDEO_CHAT_MODERATOR',
  BLOG_ADMIN= 'BLOG_ADMIN',
  AFFILIATE_USER= 'AFFILIATE_USER'
}

export type UserRegistrationStatus = 'NONE' | 'OPEN' | 'MOBILEPHONE_VERIFIED' | 'MOBILEPHONE' | 'EMAIL_VERIFICATION_AND_PASSWORD' | 'INITIAL'

export type UserRole = keyof typeof UserRoles;

export type CompanyRole = 'ROOT' | 'EMPLOYEE' | 'GUEST';

export type RegistrationRole = 'COMPANY_ROOT' | 'COMPANY_GUEST' | 'COMPANY_EMPLOYEE'

export enum UserType {
  FREELANCER = 'freelancer',
  COMPANY = 'company-root',
  GUEST = 'company-guest',
  EMPLOYEE = 'company-employee',
}

export interface BaseCompany {
  name: string;
  id: string;
  rootUserId: string;
}
export interface BaseUserWithRole {
  userId?: string;
  id?: string;
  firstname?: string;
  lastname?: string;
  salutation?: string;
  roles?: UserRole[];
  companyRole?: CompanyRole;
  role?: RegistrationRole;
  company?: BaseCompany;
}

export interface User extends BaseUserWithRole {
  userId?: string;
  fullname?: string;
  email?: string;
  preferredLocale?: Lang;
  reputationPoints?: number;
  city?: string;
  // CASL permission keys (e.g. START_CONVERSATIONS); current user only.
  permissions?: string[];
  projects?: ProjectListProject[];
}

// The fields we persist and read for the current user. This runtime list is the
// single source of truth — PersistedUser is derived from it (TS types are erased,
// so the projection in setUser needs the values at runtime). The broader
// User/ExternalUser payloads carry extra fields (city, reputationPoints, …) that
// are only relevant for *other* users (profiles, search) and are not kept here.
export const PERSISTED_USER_FIELDS = [
  'userId', 'roles', 'permissions', 'role', 'companyRole',
  'firstname', 'lastname', 'fullname',
  'company', 'preferredLocale'
] as const;

export type PersistedUser = Pick<User, typeof PERSISTED_USER_FIELDS[number]>;

export interface ExternalCompany {
  id?: string;
  name?: string;
  aboutUs?: string;
  employeeCount?: number;
  industries?: Industry[];
  members?: User[];
}

export interface ExternalUser {
  userId: string;
  firstname: string;
  lastname: string;
  company: ExternalCompany;
  companyRole: CompanyRole;
}

export interface RegisteringCompanyUserResponse {
  firstName: string;
  lastName: string;
  companyName: string;
  inviteId: string;
}

export interface SetPasswortRequest {
  smsCode?: string;
  code?: string;
  userId: string;
  newPassword: string;
}
